'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isWednesday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isWednesday.js
// module id = 564
// module chunks = 0